import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Bubble } from './Bubble';
import { GlowOrb } from './GlowOrb';
import { generateBubbles, generateOrbs } from './utils';

const Container = styled.div<{ $backgroundImage?: string }>`
  position: absolute;
  inset: 0;
  background-image: ${({ $backgroundImage }) => ($backgroundImage ? `url(${$backgroundImage})` : 'none')};
  background-size: cover;
  background-position: center;
  background-color: #1a1a2e;
  z-index: 0;
  overflow: hidden;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
`;

type MeditationBackgroundProps = {
  backgroundImage?: string;
  seed?: string;
};

export const MeditationBackground: React.FC<MeditationBackgroundProps> = ({
  backgroundImage,
  seed = 'default',
}) => {
  const bubbles = useMemo(() => generateBubbles(seed), [seed]);
  const orbs = useMemo(() => generateOrbs(seed), [seed]);

  return (
    <Container $backgroundImage={backgroundImage}>
      <Overlay>
        {orbs.map((orb) => (
          <GlowOrb key={`orb-${orb.id}`} data={orb} />
        ))}
        {bubbles.map((bubble) => (
          <Bubble key={`bubble-${bubble.id}`} data={bubble} />
        ))}
      </Overlay>
    </Container>
  );
};
